/**
 * 价格保护订单操作
 */
import Utils from "../js/utils/utils";

let PriceProtect = {
  // 获取数据列表
  getList(pg, isInvalid = false, ps = 20) {
    const options = {
      isSign: true,
      ac: "UserExtend.WorthOrderList",
      crossDomain: true,
    };

    return new Promise((resolve, reject) => {
      Utils.HttpRequest.get(
        "https://i.gwdang.com/UserExtend/WorthOrderList",
        {
          pg: pg,
          ps: ps,
          effective: isInvalid ? 0 : 1,
          platform: "pc",
        },
        options,
        (response) => {
          if (response.code == 1) {
            resolve(response.data);
          } else {
            reject(response);
          }
        }
      );
    });
  },

  // 删除
  delete(dp_ids) {
    return new Promise((resolve, reject) => {
      Utils.HttpRequest.post(
        "https://i.gwdang.com/UserExtend/WorthOrderRemove",
        {
          record_ids: dp_ids.join(","),
          platform: "pc",
        },
        {
          isSign: true,
          ac: "UserExtend.WorthOrderRemove",
          crossDomain: true,
        },
        (response) => {
          if (response.code == 1) {
            resolve(true);
          }
          reject(response);
        }
      );
    });
  },

  /**
   * 价保购买事件上报
   * @param dp_id
   * @param title
   * @param img
   * @param url
   * @param pid
   * @param uniq_id
   */
  reportEvent(dp_id, title, img, url, pid, uniq_id = "") {
    return new Promise((resolve, reject) => {
      Utils.HttpRequest.get(
        "https://i.gwdang.com/UserExtend/ReportBuyEvent",
        {
          "uniq-id": uniq_id,
          dp_id: dp_id,
          title: title,
          img: img,
          url: url,
          pid: pid,
          platform: "pc",
        },
        {
          isSign: true,
          ac: "UserExtend.ReportBuyEvent",
          crossDomain: true,
        },
        (response) => {
          if (response.code == 1) {
            resolve(response);
          }
          reject(response);
        }
      );
    });
  },
};

export default PriceProtect;
